export function loadResx(language = 'en') {
  const resourcePath = `${process.env.PUBLIC_URL || ''}/resources/resources.${language}.xml`;
  const xhr = new XMLHttpRequest();
  xhr.open('GET', resourcePath, false);
  xhr.send(null);
  if (xhr.status !== 200) throw new Error('Failed to load resource file');
  const parser = new DOMParser();
  const xml = parser.parseFromString(xhr.responseText, 'application/xml');
  const data = {};
  xml.querySelectorAll('data').forEach(node => {
    const key = node.getAttribute('name');
    const value = node.querySelector('value')?.textContent;
    if (key && value) data[key] = value;
  });
  return data;
}

export function createTranslator(resourceObj) {
  return function t(key, params) {
    let translation = resourceObj[key] || key;
    if (params) {
      Object.keys(params).forEach(paramKey => {
        const placeholder = `{${paramKey}}`; // e.g., {year}
        translation = translation.replace(placeholder, params[paramKey]);
      });
    }

    return translation;
  };
}